import React from "react";
import { Route, Navigate, useLocation, Outlet } from "react-router-dom";
import Cookies from "universal-cookie";


const PublicRoute: React.FC<{
    component: React.FC;
    path: string;
}> = (props) => {
        
    const condition = true;
    const location = useLocation();
    const cookie = new Cookies();
    console.log(props);
    let applyBlock=[
        '/favorite-partner',
        '/wallet',
        '/wallet-contract-detail',
        '/viewed-partner',
        '/my-account',
        '/home',
        '/shop','/login','/register','/forgot-password','/forgot-password-code','/session-expired','/welcome'];

    setTimeout(() => {
        if(sessionStorage.getItem('storeID') !== '' && sessionStorage.getItem('storeID') !== null){
            cookie.set('retailerId',sessionStorage.getItem('storeID'),{ path: '/' });
        }
    }, 3000);

    if(window.location.origin==process.env.REACT_APP_APPLY_URL){
         if(applyBlock.includes(location.pathname)){
            return <Navigate to="/apply" />
         }
    }

    return condition ? (<Outlet />) : (<Navigate to="/login" />);

};
export default PublicRoute;